import { Injectable } from "@angular/core";
import { ApiEndPoint } from "./api-end-point";
import { CheckUtils } from "..";
var FilesEndPoints = /** @class */ (function () {
    function FilesEndPoints(apiEndPoint) {
        this.apiEndPoint = apiEndPoint;
    }
    FilesEndPoints.prototype.upload = function (uri, files, onProgress, onFail, onLoadEnd, withToast) {
        if (CheckUtils.areEmpty(uri, files))
            return null;
        var formData = new FormData();
        formData.append("uri", uri);
        files.forEach(function (file) {
            formData.append("file", file, file.name);
        });
        return this.apiEndPoint.upload("POST", "customerportal/upload2", formData, onProgress, onFail, onLoadEnd, withToast);
    };
    FilesEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    FilesEndPoints.ctorParameters = function () { return [
        { type: ApiEndPoint, },
    ]; };
    return FilesEndPoints;
}());
export { FilesEndPoints };
//# sourceMappingURL=files-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/files-end-points.js
// module id = 382
// module chunks = 14